module.exports = __webpack_public_path__ + "img/ex_img03.64b5fb46.png";